import React, { useEffect, useState } from 'react';
import Breadcrumbs from '../components/BreadCrumbs';
import Pagination from '../components/tables/pagination/Pagination';
import CustomLoading from '../components/customLoading/CustomLoading';
import Table from '../components/tables/Table';
import loaderImage from "../assets/icons/part-logo.png";
import { Link } from 'react-router-dom';
import Button from '../components/buttons/Button';
import SearchBar from '../components/searchBar/SearchBar';
import { getEnquiries } from '../services/clinic/enquiry';
import { toast } from 'react-toastify';
import { FaCloudDownloadAlt } from 'react-icons/fa';


function EnquiryForClinicView({ forDoctor = false }) {
    const [tableData, setTableData] = useState({});
    const headers = [
        { label: "Name", key: "full_name" },
        { label: "Center", key: "center" },
        { label: "Gender | Age", key: "gender" },
        { label: "Phone", key: "phone_number" },
        { label: "Addon", key: "date" },
        { label: "Address", key: "address" },
        { label: "Converted", key: "is_converted" },
        { label: "Download", key: "download" },
    ];

    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);

    const pageSize = 10;

    const fetchData = async (query) => {
        setLoading(true);
        try {
            let res = await getEnquiries({ isDoctor: forDoctor });
            if (res.status === 200) {
                setTableData(res.data);
            } else {
                toast.error("Unable to fetch Patients");
            }
            setLoading(false);
        } catch (error) {
            console.error("Error fetching Patients:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleSearch = (query) => {
        fetchData("&search=" + query);
    };

    useEffect(() => {
        fetchData("");
    }, []);

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    return (<>
        <div className="flex flex-row justify-between items-center my-2">
            <div className="flex flex-row gap-1">
                <Breadcrumbs items={[
                    { name: 'Patients', link: "/package-invoice" },
                    { name: 'Enquiry' },
                ]} />
            </div>
            <Link to="/enquiry/add">
                <Button
                    type="button"
                    className="bg-primary text-xs text-white px-4 py-2 rounded"
                    disabled={loading}
                >
                    Add Enquiry
                </Button>
            </Link>
        </div>
        <div className="bg-white p-4 w-full rounded border-primary border-t-2">
            <div className="flex flex-row justify-end">
                <div className="md:w-[30%] lg:w-[20%] self-end">
                    <SearchBar placeholder="Search Patients..." onSearch={handleSearch} />
                </div>
            </div>
            {
                loading ?
                    <div className="flex w-full flex-row justify-center my-2">
                        <CustomLoading imageSrc={loaderImage} size={100} />
                    </div>
                    :
                    <div className="mt-2">
                        <Table
                            headers={headers}
                            rows={tableData?.results?.map((item, index) => (
                                {
                                    full_name: <b className='text-black'>{item.name}</b>,
                                    gender: <p>{item.gender} | {item.age}</p>,
                                    center: <p>{item.center}</p>,
                                    phone_number: <p>{item.phone_number}</p>,
                                    address: <p>{item.address}</p>,
                                    date: <p>{item.date}</p>,
                                    is_converted: <p className={`${item.is_converted ? "text-green-400" : "text-gray-500"} font-bold`}>{item.is_converted ? "Yes" : "No"}</p>,
                                    download: <FaCloudDownloadAlt className='text-primary cursor-pointer' size={20} onClick={() => window.open(item.pdf_file, "_blank")} />,
                                }))}
                        />
                    </div>}
            {
                tableData.count !== 0 ?
                    <div className="xl:pl-5 pl-0">
                        <Pagination
                            currentPage={currentPage}
                            totalPages={Math.ceil(tableData?.count / pageSize)}
                            pageSize={pageSize}
                            totalEntries={tableData?.count}
                            onPageChange={handlePageChange}
                            data={tableData}
                            setTableData={setTableData}
                        />
                    </div> : <></>
            }
        </div>
    </>);
}

export default EnquiryForClinicView;